import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { View, StyleSheet, Dimensions } from 'react-native';
import InfiniteGrid from './ZoomableGridView/InfiniteGrid.web';

// --- CONSTANTS ---
const GRID_SIZE = 50; // The base size of a grid cell at 1x zoom.

// --- TYPE DEFINITIONS ---
// Props for the GridBackground component.
// Kept for backward compatibility
type GridBackgroundProps = {
  zoomVar: {}; // Placeholder for external state management (legacy)
  dotMode?: boolean; // Toggles between lines and dots.
};

// The ref handle exposed to parent components.
type GridRef = {
  setZoomProps: (values: { zoomLevel: number }) => void;
};

/**
 * GridBackground (Legacy Component - Web)
 * 
 * @deprecated Use ZoomableGridView from './ZoomableGridView' instead.
 * This component is kept for backward compatibility but delegates to InfiniteGrid.
 * 
 * The new InfiniteGrid provides better performance with hardware acceleration
 * and fixed-size cells that don't scale with zoom.
 */
const GridBackground = forwardRef<GridRef, GridBackgroundProps>(({ dotMode }, ref) => {
  // Get viewport dimensions
  const { width: viewportWidth, height: viewportHeight } = Dimensions.get('window');

  // Internal state to manage the zoom level (legacy API)
  const [zoomLevel, setZoomLevel] = useState(0.4);
  
  // For legacy compatibility, we use default offsets
  const [offsetX] = useState(-1100);
  const [offsetY] = useState(-1200);

  // Expose the `setZoomProps` method for backward compatibility
  useImperativeHandle(ref, () => ({
    setZoomProps: (values) => {
      if (values.zoomLevel) {
        setZoomLevel(values.zoomLevel);
      }
    },
  }));

  // Dynamically adjust opacity based on zoom level (legacy behavior)
  const opacity = zoomLevel < 0.5 ? 0.4 : 0.2;

  return (
    <View style={styles.container} pointerEvents="none">
      <InfiniteGrid
        zoomLevel={zoomLevel}
        offsetX={offsetX}
        offsetY={offsetY}
        viewportWidth={viewportWidth + 2200} // Add buffer for old positioning
        viewportHeight={viewportHeight + 2400}
        cellSize={GRID_SIZE}
        dotMode={dotMode}
        color="grey"
        opacity={opacity}
      />
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    position: 'absolute',
    left: -1100,
    top: -1200,
    width: 3000,
    height: 3600,
    zIndex: -1,
  },
});

export default GridBackground;
